const API_BASE_URL_BY_ENV = {
  local: "http://localhost",
  staging: "https://api.johnedgecamelcase.com",
  production: "https://api.cogitofund.com",
};

const APP_ENV =
  process.env.REACT_APP_ENV ||
  (process.env.NODE_ENV === "production" ? "production" : "local");

const trimTrailingSlash = (url) => url.replace(/\/+$/, "");

export const API_BASE_URL = trimTrailingSlash(
  process.env.REACT_APP_API_BASE_URL ||
    API_BASE_URL_BY_ENV[APP_ENV] ||
    API_BASE_URL_BY_ENV.local,
);
